"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.initTransferMap = exports.RcgTransfer = void 0;
var Transfer_1 = require("./Transfer");
var Location_1 = require("./Location");
var Leaflet_1 = require("../lib/Leaflet");
var TransferService_1 = require("./TransferService");
var ChargeFilter_1 = require("./ChargeFilter");
var EmissionChartGenerator_1 = require("./EmissionChartGenerator");
var Accordion_1 = require("./Accordion");
var FormToggler_1 = require("./FormToggler");
var OebbAutocomplete_1 = require("../lib/OebbAutocomplete");
var utils_1 = require("../lib/utils");
var L = require("leaflet");
var RcgTransfer = /** @class */ (function (_super) {
    __extends(RcgTransfer, _super);
    function RcgTransfer(module, transferService, chargeFilter) {
        var _this = _super.call(this, module.querySelector('.js-rcg-transfer-map')) || this;
        _this.locationFilterOptions = [];
        _this.animationInterval = [];
        _this.isInitialZoom = true; // Prevent too much animations at the beginning
        _this.module = module;
        _this.transferService = transferService;
        _this.chargeFilter = chargeFilter;
        _this.mapElement = module.querySelector('.js-rcg-transfer-map');
        // this.title = module.querySelector('.js-rcg-transfer-title');
        // this.titleInitialText = this.title.textContent;
        _this.form = module.querySelector('.js-rcg-transfer-form');
        _this.inputFrom = module.querySelector('.js-rcg-transfer-from');
        _this.inputTo = module.querySelector('.js-rcg-transfer-to');
        _this.inputTransferDropdown = module.querySelector('.js-rcg-transfer-dropdown');
        _this.introColumn = module.querySelector('.js-rcg-transfer-content-intro');
        _this.formToggler = module.querySelector('.js-rcg-transfer-form-toggler');
        _this.contentElement = module.querySelector('.js-rcg-transfer-content');
        _this.contentColumn = module.querySelector('.js-rcg-transfer-content-column');
        _this.contentMeta = module.querySelector('.js-rcg-transfer-content-meta');
        _this.loaderElement = module.querySelector('.js-rcg-transfer-loader');
        _this.chargeFilterNoResultElement = module.querySelector('.js-rcg-transfer-charge-filter-no-result');
        _this.loaderElement.hidden = false;
        return _this;
    }
    RcgTransfer.prototype.init = function (network, cb) {
        var _this = this;
        this.checkVersion();
        this.transferService.loadNetwork(function () {
            _this.i18n = _this.transferService.getI18nStrings();
            _this.scrollNoteText = _this.i18n['railcargo.transfer.leaflet.scrollNoteText'];
            if (cb)
                cb();
            _this.initDom();
            _this.initListeners();
            _this.initScrollBehavior();
            // Remove loader
            _this.loaderElement.parentNode.removeChild(_this.loaderElement);
            if (_this.element.dataset.transfer) {
                var transferTitle = _this.element.dataset.transfer;
                _this.switchNetwork(network, false, false, false);
                _this.selectTransfers(transferTitle, false);
                _this.fitBoundsToConnection(350);
                _this.pushHistoryState(transferTitle, 'transfer');
                // Generate emission chart after SSR of content column
                var transfers = _this.transferService.getTransfersByNormalizedTitle(transferTitle);
                var baseTransfer = _this.transferService.getBaseTransfer(transfers[0]);
                _this.contentMeta.insertAdjacentHTML('beforeend', _this.renderEmissionChart(baseTransfer));
            }
            else if (_this.element.dataset.combination) {
                var combinationTitle = _this.element.dataset.combination;
                _this.switchNetwork(network, false, true, false);
                _this.selectCombination(combinationTitle, true);
                _this.pushHistoryState(combinationTitle, 'combination');
            }
            else {
                _this.switchNetwork(network);
            }
            _this.renderLocations();
        });
        // this.transferService.loadLocations(() => {
        // 	if (!this.isFullVersion) return;
        // 	this.renderLocations();
        // });
    };
    RcgTransfer.prototype.setLangNavList = function (langNavList) {
        this.langNavList = langNavList;
    };
    RcgTransfer.prototype.setBreadcrumbList = function (breadcrumbList) {
        this.breadcrumbList = breadcrumbList;
    };
    RcgTransfer.prototype.setContactUs = function (contactUs) {
        contactUs.hidden = false;
        contactUs.style.display = 'block';
        this.contactUs = document.createElement('div');
        this.contactUs.classList.add('rcg-transfer__contact-us');
        this.hideContactUs();
        var contactUsTitle = document.createElement('p');
        contactUsTitle.classList.add('rcg-transfer__contact-us-title');
        contactUsTitle.textContent = this.i18n['railcargo.transfer.contactUs.title'];
        var contactUsText = document.createElement('p');
        contactUsText.classList.add('rcg-transfer__contact-us-text');
        contactUsText.textContent = this.i18n['railcargo.transfer.contactUs.text'];
        this.contactUs.appendChild(contactUsTitle);
        this.contactUs.appendChild(contactUsText);
        this.contactUs.appendChild(contactUs);
        this.contentElement.insertBefore(this.contactUs, this.contentColumn);
    };
    RcgTransfer.prototype.setNetwork = function (network) {
        this.network = network;
    };
    RcgTransfer.prototype.getNetwork = function () {
        return this.network;
    };
    RcgTransfer.prototype.switchNetwork = function (network, keepFromTo, fitBounds, clearContentColumn) {
        var _this = this;
        if (keepFromTo === void 0) { keepFromTo = false; }
        if (fitBounds === void 0) { fitBounds = true; }
        if (clearContentColumn === void 0) { clearContentColumn = true; }
        if (this.breadcrumbList) {
            var breadcrumbListItems = this.breadcrumbList.querySelectorAll('li');
            var breadcrumbListItemLast = breadcrumbListItems.item(breadcrumbListItems.length - 1);
            var breadcrumbListItemNetwork = this.breadcrumbList.querySelector('.js-rcg-transfer-breadcrumb-network');
            var breadcrumbListItemTransfer = this.breadcrumbList.querySelector('.js-rcg-transfer-breadcrumb-transfer');
            if (breadcrumbListItemTransfer) {
                breadcrumbListItemTransfer.parentNode.removeChild(breadcrumbListItemTransfer);
                breadcrumbListItemNetwork.querySelector('.ic-arrow2-right').parentElement.removeChild(breadcrumbListItemNetwork.querySelector('.ic-arrow2-right'));
            }
            if (!breadcrumbListItemNetwork) {
                breadcrumbListItemLast.querySelector('a').insertAdjacentHTML('beforeend', '<span class="ic-arrow2-right" aria-hidden="true"></span>');
                var breadcrumbNetworkAnchor = document.createElement('a');
                breadcrumbNetworkAnchor.href = '#' + network;
                breadcrumbNetworkAnchor.dataset.network = network;
                breadcrumbNetworkAnchor.textContent = this.i18n['railcargo.transfer.' + network];
                breadcrumbNetworkAnchor.addEventListener('click', function (e) {
                    e.preventDefault();
                    _this.handleNetworkLinkClick(e.currentTarget);
                });
                var breadcrumbNetworkItem = document.createElement('li');
                breadcrumbNetworkItem.classList.add('js-rcg-transfer-breadcrumb-network');
                breadcrumbNetworkItem.appendChild(breadcrumbNetworkAnchor);
                this.breadcrumbList.appendChild(breadcrumbNetworkItem);
            }
            else {
                var breadcrumbNetworkAnchor = breadcrumbListItemNetwork.querySelector('a');
                breadcrumbNetworkAnchor.href = '#' + network;
                breadcrumbNetworkAnchor.dataset.network = network;
                breadcrumbNetworkAnchor.textContent = this.i18n['railcargo.transfer.' + network];
            }
        }
        if (network == Transfer_1.Network.All) {
            this.setTransferInDropdown();
        }
        else {
            var networkLink = this.module.querySelector('a[data-network="' + network + '"]');
            this.accordion.open(networkLink.parentElement);
            this.hideIntroColumn();
        }
        this.stationsAll = this.transferService.getStations();
        this.stationsInNetwork = this.transferService.getStations(network);
        this.networkLatLngsAll = this.transferService.getNetworkLatLngs();
        this.networkLatLngsInNetwork = this.transferService.getNetworkLatLngs(network);
        if (!keepFromTo) {
            var stationData = this.stationsAll.concat([RcgTransfer.individualWaypoint]);
            this.inputFromAutocomplete.setValue('');
            this.inputFromAutocomplete.setData(stationData);
            this.inputToAutocomplete.setValue('');
            this.setFrom();
            this.setTo();
        }
        this.setNetwork(network);
        if (clearContentColumn)
            this.clearContentColumn();
        // this.clearTitle();
        this.clearActiveTransferLayers();
        this.clearNetworkLayer();
        this.renderNetwork();
        this.renderStations();
        this.renderLocations();
        this.arrangeLayers();
        if (!this.isFullVersion) {
            this.mapElement.hidden = true;
            this.map.removeLayer(this.stationsLayer);
            this.map.removeLayer(this.networkLayer);
        }
        if (fitBounds && this.isFullVersion && this.stationsAll.length > 0) {
            if (this.network == Transfer_1.Network.Intermodal || this.network == Transfer_1.Network.All) {
                this.map.setView(RcgTransfer.latLngCenterAll, RcgTransfer.tooltipThreshold + 0.25);
            }
            else {
                this.map.fitBounds(this.networkLayer.getBounds(), RcgTransfer.boundOptions);
            }
        }
        this.stopAnimation();
        if (this.isFullVersion)
            this.startAnimation();
    };
    RcgTransfer.prototype.initDom = function () {
        var _this = this;
        if (this.styleUrl)
            (0, utils_1.loadStyle)(this.styleUrl, 'all', 'leaflet-styles');
        if (this.styleInline)
            this.addOebbLeafletStyles();
        this.map = L.map(this.element, RcgTransfer.mapOptions);
        this.map.attributionControl.setPrefix(this.attributionPrefix);
        // this.mainLayer = L.tileLayer(`${this.url}/{z}/{x}/{y}.png`, {
        // 	attribution: '<a href="http://openmaptiles.org/" rel="nofollow">© OpenMapTiles</a> <a href="http://www.openstreetmap.org/copyright" rel="nofollow">© OpenStreetMap contributors</a>',
        // 	maxZoom: 14,
        // }).addTo(this.map);
        fetch(encodeURI('/.resources/corp-2016/themes/rcg-transnet/countries.js'))
            .then(function (response) { return response.json(); })
            .then(function (countriesData) {
            L.geoJSON(countriesData, {
                // clickable: true,
                style: {
                    stroke: true,
                    weight: 2,
                    color: '#cccccc',
                    fill: true,
                    fillColor: '#fff',
                    fillOpacity: 1,
                },
            }).addTo(_this.map);
        });
        this.map.setView([47.7313, 13.5479], 7);
        this.map.setMaxBounds([
            [65.88386806685818, 162.4602930738061],
            [9.99907991715752, -27.452831453923405]
        ]);
        this.map.attributionControl.setPosition('bottomright');
        new L.Control.Zoom({ position: 'topleft' }).addTo(this.map);
        document.body.classList.add('rcg-transfer');
        this.networkLayer = L.featureGroup([]).addTo(this.map);
        this.stationsLayer = L.featureGroup([]).addTo(this.map);
        this.connectionLinesLayer = L.featureGroup([]).addTo(this.map);
        this.connectionStopsLayer = L.featureGroup([]).addTo(this.map);
        this.locationsLayer = L.featureGroup([]).addTo(this.map);
        this.map.createPane('rcg-transfer-network');
        this.map.createPane('rcg-transfer-active');
        this.map.createPane('rcg-transfer-station-tooltip');
        this.map.createPane('rcg-transfer-locations-cluster');
        (0, OebbAutocomplete_1.addOebbautocompleteDefaultStyle)();
        var that = this;
        // From Field
        this.inputFrom.value = '';
        this.inputFromAutocomplete = new OebbAutocomplete_1.OebbAutocomplete(this.module.querySelector('.js-rcg-transfer-from'))
            .withTemplate(function (station) {
            var item = station.title;
            var value = this.getValue();
            if (station.title == Transfer_1.individual) {
                return "\n\t\t\t\t\t\t<li class=\"oebb-autocomplete-item js-oebb-autocomplete-item\">\n\t\t\t\t\t\t\t".concat(icon('dep-arr-individual'), " ").concat(that.i18n['railcargo.transfer.fromToIndividual'], "\n\t\t\t\t\t\t</li>\n\t\t\t\t\t");
            }
            if (value.length > 0 && item.toLowerCase().indexOf(value.toLowerCase()) === 0) {
                return "\n\t\t\t\t\t\t<li class=\"oebb-autocomplete-item js-oebb-autocomplete-item\">\n\t\t\t\t\t\t\t".concat(item.substring(0, value.length) + "<strong>" + item.substring(value.length), "</strong>\n\t\t\t\t\t\t</li>");
            }
            return "<li class=\"oebb-autocomplete-item js-oebb-autocomplete-item\">".concat(station.title, "</li>");
        })
            .withFirstItemOnEnter()
            .withPanelOnFocus()
            .onKeyup(function (e) {
            var _this = this;
            var data = [];
            if (!this.getValue())
                that.setFrom();
            data = that.stationsAll.filter(function (station) {
                var match = false;
                if (station.title.toLowerCase().indexOf(_this.getValue().toLowerCase()) === 0)
                    match = true;
                if (station.synonyms) {
                    for (var _i = 0, _a = station.synonyms; _i < _a.length; _i++) {
                        var synonym = _a[_i];
                        if (synonym.toLowerCase().indexOf(_this.getValue().toLowerCase()) === 0)
                            match = true;
                    }
                }
                return match;
            });
            data.push(RcgTransfer.individualWaypoint);
            this.setData(data);
        })
            .onItemActive(function (index) {
            var item = this.getData()[index];
            if (item.title == Transfer_1.individual) {
                this.setValue('');
                this.hideList();
                return;
            }
            this.setValue(item.title);
        })
            .onItemSelect(function (index) {
            var station = this.getData()[index];
            var stationName = station.title;
            if (stationName == Transfer_1.individual) {
                this.hideList();
                that.setFrom();
                that.setTo();
                setTimeout(function () { return that.inputFrom.blur(); });
                that.renderConnectionInformation(RcgTransfer.individualConnection);
                return;
            }
            // that.setFrom(stationName);
            that.handleStationMarkerClick(station);
            setTimeout(function () { return that.inputTo.focus(); });
        });
        // To Field
        this.inputTo.value = '';
        this.inputTo.disabled = true;
        this.inputToAutocomplete = new OebbAutocomplete_1.OebbAutocomplete(this.module.querySelector('.js-rcg-transfer-to'))
            .withTemplate(function (connection) {
            var item = connection.stationTo;
            var value = this.getValue();
            if (connection.stationFrom == Transfer_1.individual || connection.stationTo == Transfer_1.individual) {
                return "\n\t\t\t\t\t\t<li class=\"oebb-autocomplete-item js-oebb-autocomplete-item\">\n\t\t\t\t\t\t\t".concat(icon('dep-arr-individual'), " ").concat(that.i18n['railcargo.transfer.fromToIndividual'], "\n\t\t\t\t\t\t</li>\n\t\t\t\t\t");
            }
            if (item.toLowerCase().indexOf(value.toLowerCase()) === 0) {
                return "\n\t\t\t\t\t\t<li class=\"oebb-autocomplete-item js-oebb-autocomplete-item\">\n\t\t\t\t\t\t\t".concat(icon(connection.transfers[0].network), " ").concat(connection.stationFrom, "-").concat(item.substring(0, value.length) + "<strong>" + item.substring(value.length), "</strong> ").concat(connection.via ? '(via ' + connection.via + ')' : '', "\n\t\t\t\t\t\t</li>\n\t\t\t\t\t");
            }
            return "\n\t\t\t\t\t<li class=\"oebb-autocomplete-item js-oebb-autocomplete-item\">\n\t\t\t\t\t\t".concat(icon(connection.transfers[0].network), " ").concat(that.getConnectionTitle(connection), "\n\t\t\t\t\t\t").concat(connection.via ? '(via ' + connection.via + ')' : '', "\n\t\t\t\t\t</li>\n\t\t\t\t");
        })
            .withFirstItemOnEnter()
            .withPanelOnFocus()
            .onKeyup(function (e) {
            var _this = this;
            var data = [];
            data = that.connectionsByFromStation.filter(function (connection) {
                var match = false;
                if (connection.stationTo.toLowerCase().indexOf(_this.getValue().toLowerCase()) > -1)
                    match = true;
                if (connection.stationToSynonyms) {
                    for (var _i = 0, _a = connection.stationToSynonyms; _i < _a.length; _i++) {
                        var synonym = _a[_i];
                        if (synonym.toLowerCase().indexOf(_this.getValue().toLowerCase()) > -1)
                            match = true;
                    }
                }
                return match;
            });
            data.push(RcgTransfer.individualConnection);
            this.setData(data);
        })
            .onItemActive(function (index) {
            var connection = this.getData()[index];
            var stationName = connection.stationTo;
            if (connection.stationFrom == Transfer_1.individual || connection.stationTo == Transfer_1.individual) {
                this.hideList();
                this.setValue('');
                return;
            }
            this.setValue(stationName);
        })
            .onItemSelect(function (index) {
            var connection = this.getData()[index];
            var stationName = connection.stationTo;
            if (stationName == Transfer_1.individual) {
                this.hideList();
                that.setFrom();
                that.setTo();
                that.renderConnectionInformation(connection);
                setTimeout(function () { return that.inputTo.blur(); });
                that.clearActiveTransferLayers();
                return;
            }
            if (connection.transfers[0].network != that.network) {
                that.switchNetwork(connection.transfers[0].network, true, false);
            }
            that.setTo(stationName);
            that.clearActiveTransferLayers();
            that.renderConnection(connection);
            that.renderConnectionInformation(connection);
            that.fitBoundsToConnection(350);
            if (connection.combinationReference) {
                that.chargeFilter.setEnabledOptions(that.transferService.getMatchingChargeFromTransfers(connection.transfers));
            }
            else {
                that.chargeFilter.setEnabledOptions(that.transferService.getPossibleChargeFromTransfers(connection.transfers));
            }
        });
        this.accordion = new Accordion_1.Accordion(this.inputTransferDropdown, 'js-rcg-transfer-dropdown-handler', 'js-rcg-transfer-dropdown');
        // FormToggler
        new FormToggler_1.FormToggler(this.formToggler);
        // Reload Button
        var reloadButton = document.createElement('button');
        reloadButton.innerHTML = icon('reload');
        reloadButton.classList.add('rcg-transfer-reload');
        reloadButton.addEventListener('click', function (e) {
            e.preventDefault();
            _this.reload();
        });
        this.mapElement.querySelector('.leaflet-control-zoom').appendChild(reloadButton);
    };
    RcgTransfer.prototype.initListeners = function () {
        var _this = this;
        _super.prototype.initListeners.call(this);
        window.onpopstate = function (e) {
            if (!e.state)
                return;
            if (e.state.documentTitle)
                _this.setDocumentTitle(e.state.documentTitle);
            if (e.state.type == 'transfer') {
                var transfer = _this.transferService.getTransfersByNormalizedTitle(e.state.title)[0];
                if (!transfer.titleRu)
                    console.warn('Missing russian title for transfer: ' + transfer.name);
                if (!transfer.titleBg)
                    console.warn('Missing bulgarian title for transfer: ' + transfer.name);
                _this.setTransferInLangNav({
                    default: "/transfer/".concat(_this.getTransferTitleToUrlPart(_this.transferService.combineTransferTitleWithSuffix(transfer.titleOriginal, transfer === null || transfer === void 0 ? void 0 : transfer.titleSuffix))),
                    ru: "/transfer/".concat(_this.getTransferTitleToUrlPart(transfer.titleRu ? _this.transferService.combineTransferTitleWithSuffix(transfer.titleRu, transfer === null || transfer === void 0 ? void 0 : transfer.titleSuffix) : _this.transferService.combineTransferTitleWithSuffix(transfer.title, transfer === null || transfer === void 0 ? void 0 : transfer.titleSuffix))),
                    bg: "/transfer/".concat(_this.getTransferTitleToUrlPart(transfer.titleBg ? _this.transferService.combineTransferTitleWithSuffix(transfer.titleBg, transfer === null || transfer === void 0 ? void 0 : transfer.titleSuffix) : _this.transferService.combineTransferTitleWithSuffix(transfer.title, transfer === null || transfer === void 0 ? void 0 : transfer.titleSuffix))),
                });
                _this.selectTransfers(e.state.title);
                _this.fitBoundsToConnection();
            }
            else if (e.state.type == 'combination') {
                _this.setTransferInLangNav({
                    default: "~combination~".concat(e.state.title, "~"),
                    ru: "~combinaton~".concat(e.state.title, "~"),
                    bg: "~combinaton~".concat(e.state.title, "~"),
                });
                _this.setTransferInDropdown();
                _this.selectCombination(e.state.title);
            }
            else if (e.state.type == 'network') {
                _this.setTransferInLangNav();
                _this.setTransferInDropdown();
                _this.switchNetwork(e.state.title);
            }
            else {
                _this.setTransferInLangNav();
                _this.setTransferInDropdown();
                _this.switchNetwork(Transfer_1.Network.All);
            }
        };
        var lastUseMap = this.isFullVersion;
        window.addEventListener('resize', function () {
            _this.checkVersion();
            if (_this.isFullVersion && _this.isFullVersion != lastUseMap) {
                // Break to desktop
                _this.mapElement.hidden = false;
                _this.map.invalidateSize();
                _this.map.addLayer(_this.networkLayer);
                _this.map.addLayer(_this.stationsLayer);
                _this.map.addLayer(_this.locationsLayer);
                _this.arrangeLayers();
                document.querySelector('.js-rcg-transfer-transnet-filter').checked = false;
            }
            if (!_this.isFullVersion && _this.isFullVersion != lastUseMap) {
                // Break to mobile
                _this.mapElement.hidden = (_this.contentColumn.textContent) ? false : true;
                _this.map.invalidateSize();
                _this.map.removeLayer(_this.stationsLayer);
                _this.map.removeLayer(_this.networkLayer);
                _this.map.removeLayer(_this.locationsLayer);
                if (!_this.mapElement.hidden)
                    _this.map.fitBounds(_this.connectionLinesLayer.getBounds(), RcgTransfer.boundOptionsMobile);
                _this.reload();
            }
            lastUseMap = _this.isFullVersion;
        });
        this.chargeFilter.onOptionsChange(function () {
            _this.reloadWithCharge(_this.chargeFilter.getFilterOptions());
        });
        this.module.querySelector('.js-rcg-transfer-charge-filter-no-result-button').addEventListener('click', function (e) {
            e.preventDefault();
            _this.reload();
        });
        this.module.querySelector('.js-rcg-transfer-form').addEventListener('submit', function (e) { return e.preventDefault(); });
        // this.inputFrom.addEventListener('focus', () => {
        // 	this.clearActiveTransferLayers();
        // });
        var networkLinks = this.module.querySelectorAll('.js-rcg-transfer-dropdown-handler'); // as NodeListOf<HTMLAnchorElement>;
        for (var i = 0; i < networkLinks.length; i++) {
            networkLinks[i].addEventListener('click', function (e) {
                e.preventDefault();
                _this.handleNetworkLinkClick(e.currentTarget);
            });
        }
        var transferLinks = this.module.querySelectorAll('.js-rcg-transfer-from-list');
        for (var i = 0; i < transferLinks.length; i++) {
            transferLinks[i].addEventListener('click', function (e) {
                e.preventDefault();
                _this.handleTransferLinkClick(e.currentTarget);
            }, false);
        }
        var filterLocations = document.querySelectorAll('.js-rcg-transfer-location-filter');
        for (var i = 0; i < filterLocations.length; i++) {
            var currentField = filterLocations[i];
            currentField.checked = false;
            currentField.addEventListener('change', function (e) {
                var target = e.target;
                if (target.checked) {
                    if (_this.locationFilterOptions.indexOf(target.value) == -1)
                        _this.locationFilterOptions.push(target.value);
                }
                else {
                    if (_this.locationFilterOptions.indexOf(target.value) > -1) {
                        _this.locationFilterOptions.splice(_this.locationFilterOptions.indexOf(target.value), 1);
                    }
                }
                _this.clearLocationsLayer();
                _this.renderLocations();
            });
        }
        var filterTransnet = document.querySelector('.js-rcg-transfer-transnet-filter');
        filterTransnet.checked = false;
        filterTransnet.addEventListener('change', function (e) {
            var target = e.target;
            if (target.checked) {
                _this.map.removeLayer(_this.stationsLayer);
                _this.map.removeLayer(_this.networkLayer);
                _this.stopAnimation();
            }
            else {
                _this.map.addLayer(_this.stationsLayer);
                _this.map.addLayer(_this.networkLayer);
                _this.clearLocationsLayer();
                _this.renderLocations();
                _this.arrangeLayers();
                if (_this.isFullVersion)
                    _this.startAnimation();
            }
        });
        this.map.on('click', function (e) {
            if (_this.isFullVersion && (_this.stationFrom || _this.stationTo)) {
                _this.switchNetwork(_this.network, false, false);
            }
        });
        this.map.on('zoomend', function () {
            var zoom = _this.map.getZoom();
            if (zoom >= RcgTransfer.tooltipThreshold) {
                _this.stationsLayer.eachLayer(function (l) {
                    if (l.getTooltip && l.getTooltip()) {
                        var tooltip = l.getTooltip();
                        if (tooltip.getElement()) {
                            l.unbindTooltip().bindTooltip(tooltip, {
                                permanent: tooltip.getElement().classList.contains('js-rcg-transfer-station-tooltip-permanent') ? true : false,
                            });
                        }
                        else {
                            l.unbindTooltip().bindTooltip(tooltip, {
                                permanent: false,
                            });
                        }
                    }
                });
            }
            else if (zoom < RcgTransfer.tooltipThreshold) {
                _this.stationsLayer.eachLayer(function (l) {
                    if (l.getTooltip && l.getTooltip()) {
                        var tooltip = l.getTooltip();
                        l.unbindTooltip().bindTooltip(tooltip, {
                            permanent: false,
                        });
                    }
                });
            }
            if (!_this.isInitialZoom) {
                _this.stopAnimation();
                _this.startAnimation();
            }
            else {
                _this.isInitialZoom = false;
            }
        });
        // this.map.on('moveend', function () {
        // 	console.log(this.getCenter());
        // });
    };
    RcgTransfer.prototype.checkVersion = function () {
        this.isFullVersion = (window.innerWidth > 991) ? true : false;
    };
    // Assuming there is never a trailing slash: "transnet/"
    RcgTransfer.prototype.pushHistoryState = function (title, type) {
        if (type === void 0) { type = null; }
        var documentTitleParts = document.title.split(' - ');
        var documentTitle = '';
        var page = window.location.pathname
            .split('~')[0] // Remove Selector if any
            .split('/transfer').shift().split('/combination').shift(); // Remove "/transfer" or "/combination"
        var url = null;
        if (!type) {
            this.setTransferInLangNav();
            if (documentTitleParts.length == 4) {
                documentTitleParts.splice(2, 1);
            }
            documentTitle = documentTitleParts.join(' - ');
            this.setDocumentTitle(documentTitle);
            return history.pushState({
                title: null,
                type: null,
                documentTitle: documentTitle,
            }, documentTitle, "".concat(page));
        }
        var transfer = this.transferService.getTransfersByNormalizedTitle(title)[0];
        switch (type) {
            case 'transfer':
                url = "".concat(page, "/transfer/").concat(this.getTransferTitleToUrlPart(title));
                if (!transfer.titleRu)
                    console.warn('Missing russian title for transfer: ' + transfer.name);
                if (!transfer.titleBg)
                    console.warn('Missing bulgarian title for transfer: ' + transfer.name);
                this.setTransferInLangNav({
                    default: "/transfer/".concat(this.getTransferTitleToUrlPart(this.transferService.combineTransferTitleWithSuffix(transfer.titleOriginal, transfer === null || transfer === void 0 ? void 0 : transfer.titleSuffix))),
                    ru: "/transfer/".concat(this.getTransferTitleToUrlPart(transfer.titleRu ? this.transferService.combineTransferTitleWithSuffix(transfer.titleRu, transfer === null || transfer === void 0 ? void 0 : transfer.titleSuffix) : this.transferService.combineTransferTitleWithSuffix(transfer.title, transfer === null || transfer === void 0 ? void 0 : transfer.titleSuffix))),
                    bg: "/transfer/".concat(this.getTransferTitleToUrlPart(transfer.titleBg ? this.transferService.combineTransferTitleWithSuffix(transfer.titleBg, transfer === null || transfer === void 0 ? void 0 : transfer.titleSuffix) : this.transferService.combineTransferTitleWithSuffix(transfer.title, transfer === null || transfer === void 0 ? void 0 : transfer.titleSuffix))),
                });
                if (documentTitleParts.length == 4) {
                    documentTitleParts[2] = transfer.title;
                }
                else {
                    var titleWithSuffix = this.transferService.splitTransferTitleFromSuffix(title);
                    documentTitleParts.splice(documentTitleParts.length - 1, 0, titleWithSuffix.title);
                }
                documentTitle = documentTitleParts.join(' - ');
                break;
            case 'combination':
                var selector = "/".concat(type, "/").concat(title);
                url = page + selector;
                this.setTransferInLangNav({
                    default: selector,
                    ru: selector,
                    bg: selector,
                });
                if (documentTitleParts.length == 4) {
                    var combination = this.transferService.getCombination(title);
                    documentTitleParts[2] = combination.from + '–' + combination.to;
                }
                else {
                    documentTitleParts.splice(documentTitleParts.length - 1, 0, title);
                }
                documentTitle = documentTitleParts.join(' - ');
                break;
            case 'network':
                this.setTransferInLangNav();
                url = page;
                if (documentTitleParts.length == 4) {
                    documentTitleParts.splice(2, 1);
                }
                documentTitle = documentTitleParts.join(' - ');
            default:
                if (documentTitleParts.length == 4) {
                    documentTitleParts.splice(2, 1);
                }
                documentTitle = documentTitleParts.join(' - ');
                break;
        }
        this.setDocumentTitle(documentTitle);
        history.pushState({
            title: title,
            type: type,
            documentTitle: documentTitle,
        }, documentTitle, url);
    };
    RcgTransfer.prototype.handleStationMarkerClick = function (station) {
        var _this = this;
        if (this.stationFrom && this.stationTo) {
            this.clearActiveTransferLayers();
            this.clearContentColumn();
            this.setFrom();
            this.setTo();
        }
        var setStationFrom = function (station) {
            _this.clearActiveTransferLayers();
            _this.setFrom(station.title);
            _this.setTo();
            _this.connectionStopsLayer.addLayer(
            // L.circleMarker(
            // 	[station.latitude, station.longitude],
            // 	RcgTransfer.markerOptions['station-general-active']
            // )
            L.marker([station.latitude, station.longitude], { icon: RcgTransfer.markerStationActive })
                .on('click', function () { return _this.handleStationMarkerClick(station); }));
            var possibleStationsByFromStation = _this.connectionsByFromStation.map(function (connection) { return connection.stationTo; });
            for (var _i = 0, _a = _this.connectionsByFromStation; _i < _a.length; _i++) {
                var connection = _a[_i];
                _this.renderPossibleTransfers(connection.stationFrom, connection.transfers, _this.network != Transfer_1.Network.All ? _this.network : null, possibleStationsByFromStation);
                // this.renderPossibleTransfers(connection.stationFrom, connection.transfers, this.network);
                _this.inputTo.focus();
            }
            _this.connectionStopsLayer.bringToFront();
        };
        if (!this.stationFrom) {
            setStationFrom(station);
        }
        else if (!this.stationTo) {
            var connection = void 0;
            for (var _i = 0, _a = this.connectionsByFromStation; _i < _a.length; _i++) {
                var possibleConnection = _a[_i];
                if (possibleConnection.stationTo == station.title) {
                    connection = possibleConnection;
                    break;
                }
            }
            this.connectionStopsLayer.clearLayers();
            if (connection) {
                this.clearActiveTransferLayers();
                this.setTo(connection.stationTo);
                this.connectionStopsLayer.addLayer(
                // L.circleMarker(
                // 	[station.latitude, station.longitude],
                // 	RcgTransfer.markerOptions['station-general-active']
                // )
                L.marker([station.latitude, station.longitude], { icon: RcgTransfer.markerStationActive })
                    .on('click', function () { return _this.handleStationMarkerClick(station); }));
                if (connection.transfers[0].network != this.network)
                    this.switchNetwork(connection.transfers[0].network, true);
                this.renderConnection(connection);
                this.renderConnectionInformation(connection);
                this.fitBoundsToConnection();
                if (connection.combinationReference) {
                    this.chargeFilter.setEnabledOptions(this.transferService.getMatchingChargeFromTransfers(connection.transfers));
                }
                else {
                    this.chargeFilter.setEnabledOptions(this.transferService.getPossibleChargeFromTransfers(connection.transfers));
                }
            }
            else {
                this.clearContentColumn();
                this.clearActiveTransferLayers();
                setStationFrom(station);
            }
        }
    };
    RcgTransfer.prototype.handleNetworkLinkClick = function (link) {
        if (link.parentElement.classList.contains('open')) {
            this.reload();
            return;
        }
        this.accordion.closeAllAccordions();
        this.accordion.open(link.parentElement);
        if (this.chargeFilter.isFilteringActive()) {
            this.chargeFilter.reset();
            this.transferService.filterByCharge([]);
        }
        var network = link.dataset.network;
        // if (network != this.network) this.switchNetwork(network as Network); // Prevents reset of current result
        this.pushHistoryState(network, 'network');
        this.switchNetwork(network);
        var possibleChargeForNetwork = this.transferService.getPossibleChargeFromTransfersByNetwork(network);
        this.chargeFilter.setEnabledOptions(possibleChargeForNetwork);
    };
    RcgTransfer.prototype.handleTransferLinkClick = function (link) {
        if (this.chargeFilter.isFilteringActive()) {
            this.chargeFilter.reset();
            this.transferService.filterByCharge([]);
            this.switchNetwork(Transfer_1.Network.All);
        }
        var transferTitle = link.dataset.transferTitle;
        var transferSuffix = link.dataset.transferSuffix;
        var transferTitleWithSuffix = this.transferService.combineTransferTitleWithSuffix(transferTitle, transferSuffix);
        // this.reload();
        this.selectTransfers(transferTitleWithSuffix);
        this.fitBoundsToConnection();
        this.pushHistoryState(transferTitleWithSuffix, 'transfer');
    };
    RcgTransfer.prototype.selectTransfers = function (transferTitle, withConnectionInformation) {
        var _a;
        if (withConnectionInformation === void 0) { withConnectionInformation = true; }
        var transfers = this.transferService.getTransfersByNormalizedTitle(transferTitle);
        this.inputFrom.value = '';
        this.inputTo.value = '';
        this.stationFrom = null;
        this.stationTo = null;
        this.setTransferInDropdown(transfers[0]);
        this.clearActiveTransferLayers();
        var activeLabels = [];
        for (var _i = 0, transfers_1 = transfers; _i < transfers_1.length; _i++) {
            var transfer = transfers_1[_i];
            if (transfer.network != this.network) {
                this.switchNetwork(transfer.network, false, true, withConnectionInformation);
            }
            this.renderTransfer(transfer, activeLabels);
            this.chargeFilter.setEnabledOptions((_a = transfer.charge) !== null && _a !== void 0 ? _a : []);
        }
        this.renderConnectionInformation({
            transfers: [transfers[0]], // Only first transfer, because information is the same in all transfers
        }, withConnectionInformation);
        var titleParts = transfers[0].title.split('-').join('|').split('–').join('|').split('|');
        this.setFrom(titleParts.shift());
        this.setTo(titleParts.pop());
    };
    RcgTransfer.prototype.selectCombination = function (combinationName, withConnectionInformation) {
        if (withConnectionInformation === void 0) { withConnectionInformation = true; }
        var combination = this.transferService.getCombination(combinationName);
        var connection;
        if (!combination)
            return;
        this.setFrom(combination.from);
        this.setTo(combination.to);
        for (var _i = 0, _a = this.connectionsByFromStation; _i < _a.length; _i++) {
            var connectionByFromStation = _a[_i];
            if (connectionByFromStation.stationFrom == combination.from && connectionByFromStation.stationTo == combination.to) {
                connection = connectionByFromStation;
                break;
            }
        }
        if (!connection)
            return;
        this.clearActiveTransferLayers();
        if (connection.transfers[0].network != this.network) {
            this.switchNetwork(connection.transfers[0].network, true, false, false);
        }
        this.renderConnection(connection);
        this.renderConnectionInformation(connection, withConnectionInformation);
        this.fitBoundsToConnection(350);
        this.chargeFilter.setEnabledOptions(this.transferService.getMatchingChargeFromTransfers(connection.transfers));
        this.pushHistoryState(combinationName, 'combination');
    };
    RcgTransfer.prototype.setFrom = function (stationName) {
        if (!stationName) {
            this.stationFrom = null;
            this.transfersByFromStation = [];
            this.connectionsByFromStation = [];
            this.inputFromAutocomplete.setValue('');
        }
        else {
            this.stationFrom = stationName;
            this.transfersByFromStation = this.transferService.getTransfersByDepartureStation(stationName);
            this.connectionsByFromStation = this.transferService.getConnectionsFromTransfersByDepartureStation(this.transfersByFromStation, this.stationFrom);
            this.inputFromAutocomplete.setValue(stationName);
        }
        this.inputToAutocomplete.setValue('');
        this.inputToAutocomplete.setData(this.connectionsByFromStation.concat([RcgTransfer.individualConnection]));
        if (this.inputTo.disabled)
            this.inputTo.disabled = false;
    };
    RcgTransfer.prototype.setTo = function (stationName) {
        if (this.inputTo.disabled)
            this.inputTo.disabled = false;
        if (stationName) {
            this.inputToAutocomplete.setValue(stationName);
            this.stationTo = stationName;
        }
        else {
            this.inputToAutocomplete.setValue('');
            this.stationTo = null;
        }
    };
    RcgTransfer.prototype.setDocumentTitle = function (title) {
        document.title = title;
        document.querySelector('[property="og:title"]').content = title.split(' - ').length == 4 ? title.split(' - ')[2] : title;
    };
    RcgTransfer.prototype.setTransferInDropdown = function (transfer) {
        var transferLinks = this.module.querySelectorAll('.rcg-transfer__dropdown-child--active');
        for (var i = 0; i < transferLinks.length; i++) {
            if (transferLinks[i].classList.contains('rcg-transfer__dropdown-child--active')) {
                transferLinks[i].classList.remove('rcg-transfer__dropdown-child--active');
            }
        }
        this.accordion.closeAllAccordions();
        if (!transfer)
            return;
        var link = this.module.querySelector('a[data-transfer-title="' + this.transferService.combineTransferTitleWithSuffix(transfer.title, transfer.titleSuffix) + '"]');
        link.classList.add('rcg-transfer__dropdown-child--active');
        this.accordion.toggle(link.parentElement.parentElement);
        if (!(0, utils_1.isElementInViewport)(link, link.parentElement.parentElement)) {
            var topPosition = link.offsetTop - link.parentElement.parentElement.offsetTop;
            link.parentElement.parentElement.scrollTop = topPosition;
        }
    };
    RcgTransfer.prototype.setTransferInLangNav = function (selectors) {
        if (!this.langNavList)
            return;
        var selector = '';
        var selectorRu = '';
        var selectorBg = '';
        if (selectors) {
            selector = selectors.default;
            selectorRu = selectors.ru;
            selectorBg = selectors.bg;
        }
        var langNavLinks = this.langNavList.querySelectorAll('li a');
        for (var i = 0; i < langNavLinks.length; i++) {
            var langNavLink = langNavLinks[i];
            var selectorForLangNavItem = void 0;
            if (langNavLink.href.indexOf('/ru/') > 0) {
                selectorForLangNavItem = selectorRu;
            }
            else if (langNavLink.href.indexOf('/bg/') > 0) {
                selectorForLangNavItem = selectorBg;
            }
            else {
                selectorForLangNavItem = selector;
            }
            langNavLink.href = langNavLink.href
                .split('~')[0] // Remove Selector if any
                .split('/transfer').shift() // Remove "/transfer"
                .split('/combination').shift() // Remove "/combination"
                + selectorForLangNavItem; // Add selector for language
        }
        var isRuActive = document.querySelector('.lang-dd-nav-current').textContent.trim().toLowerCase() == 'ru';
        var isBgActive = document.querySelector('.lang-dd-nav-current').textContent.trim().toLowerCase() == 'bg';
        var canonicalLink = document.querySelector('[rel="canonical"]');
        canonicalLink.href = canonicalLink.href.split('/transfer').shift().split('/combination').shift() + (function () {
            if (isRuActive)
                return selectorRu;
            if (isBgActive)
                return selectorBg;
            return selector;
        })();
        var alternateLinks = document.querySelectorAll('[rel="alternate"]');
        for (var i = 0; i < alternateLinks.length; i++) {
            var selectorForAlternateLink = void 0;
            if (alternateLinks[i].hreflang == 'ru') {
                selectorForAlternateLink = selectorRu;
            }
            else if (alternateLinks[i].hreflang == 'bg') {
                selectorForAlternateLink = selectorBg;
            }
            else {
                selectorForAlternateLink = selector;
            }
            alternateLinks[i].href = alternateLinks[i].href
                .split('/transfer').shift()
                .split('/combination').shift()
                + selectorForAlternateLink;
        }
    };
    RcgTransfer.prototype.arrangeLayers = function () {
        this.networkLayer.bringToFront();
        this.stationsLayer.bringToFront();
        this.connectionLinesLayer.bringToFront();
        this.connectionStopsLayer.bringToFront();
        this.locationsLayer.bringToFront();
        // Tooltip-Pane default is 650
        // Marker-Pane default is 600
        this.mapElement.querySelector('.leaflet-rcg-transfer-station-tooltip-pane').style.zIndex = '610';
        // (this.mapElement.querySelector('.leaflet-rcg-transfer-locations-cluster-pane') as HTMLElement).style.zIndex = '640';
        this.mapElement.querySelector('.leaflet-marker-pane').style.zIndex = '620';
    };
    RcgTransfer.prototype.startAnimation = function () {
        var _this = this;
        if (this.networkLayer.getLayers().length === 0)
            return; // No network layers for animation
        var trainLength = RcgTransfer.animationOptions.trainLength;
        var trainSpeed = RcgTransfer.animationOptions.trainSpeed;
        var trainAnimationDurationThreshold = RcgTransfer.animationOptions.trainAnimationDurationThreshold;
        var trainAmount = this.connectionLinesLayer.getLayers().length > 0 ? 0 : RcgTransfer.animationOptions.concurrent;
        var animate = function () {
            var color = '#e2002a';
            var randomIndex = Math.floor(Math.random() * _this.networkLayer.getLayers().length);
            var polylineLayer = _this.networkLayer.getLayers()[randomIndex];
            var clonedLayerPath = polylineLayer._path.cloneNode();
            var pathLength = clonedLayerPath.getTotalLength();
            var duration = Math.round(pathLength) * trainSpeed;
            // Override for active lines
            if (_this.connectionLinesLayer.getLayers().length > 0) {
                color = '#4c4c4c';
                randomIndex = Math.floor(Math.random() * _this.connectionLinesLayer.getLayers().length);
                polylineLayer = _this.connectionLinesLayer.getLayers()[randomIndex];
                clonedLayerPath = polylineLayer._path.cloneNode();
                pathLength = clonedLayerPath.getTotalLength();
                duration = Math.round(pathLength) * trainSpeed;
            }
            if (duration < trainAnimationDurationThreshold)
                duration = trainAnimationDurationThreshold;
            clonedLayerPath.classList.add('js-rcg-transfer-animation-path');
            clonedLayerPath.setAttribute('stroke', 'transparent');
            clonedLayerPath.setAttribute('stroke-width', '0');
            clonedLayerPath.style.strokeDasharray = "".concat(trainLength, ",").concat(pathLength + (trainLength * 2));
            clonedLayerPath.style.strokeDashoffset = "".concat((trainLength * 2));
            clonedLayerPath.style.transition = "stroke-dashoffset ".concat(duration / 1000, "s linear");
            // Start actual animation
            setTimeout(function () {
                if (!clonedLayerPath)
                    return;
                clonedLayerPath.setAttribute('stroke', color);
                clonedLayerPath.setAttribute('stroke-width', '6');
                clonedLayerPath.style.strokeDashoffset = "".concat(pathLength + (trainLength * 4));
            }, 10);
            // Animate back
            setTimeout(function () {
                if (!clonedLayerPath)
                    return;
                clonedLayerPath.style.strokeDashoffset = "".concat(trainLength);
            }, 10 + duration);
            // Remove path
            setTimeout(function () {
                if (!clonedLayerPath || !clonedLayerPath.parentNode)
                    return;
                clonedLayerPath.parentNode.removeChild(clonedLayerPath);
            }, 10 + (duration * 2));
            if (_this.connectionLinesLayer.getLayers().length > 0) {
                document.querySelector('.leaflet-rcg-transfer-active-pane svg').appendChild(clonedLayerPath);
            }
            else {
                document.querySelector('.leaflet-rcg-transfer-network-pane svg').appendChild(clonedLayerPath);
            }
        };
        for (var i = 0; i < (trainAmount + 1); i++) {
            this.stopAnimation();
            var animationInterval = setInterval(animate, RcgTransfer.animationOptions.interval);
            this.animationInterval.push(animationInterval);
            setTimeout(function () { return animate(); }, 750); // Initial animation, immediately after start, with little timeout to wait for map
        }
    };
    RcgTransfer.prototype.stopAnimation = function () {
        if (this.animationInterval.length > 0) {
            for (var _i = 0, _a = this.animationInterval; _i < _a.length; _i++) {
                var animationInterval = _a[_i];
                clearInterval(animationInterval);
            }
        }
        var animationPathsNetwork = document.querySelectorAll('.leaflet-rcg-transfer-network-pane svg .js-rcg-transfer-animation-path');
        animationPathsNetwork.forEach(function (element) { return element.parentNode.removeChild(element); });
        var animationPathsActive = document.querySelectorAll('.leaflet-rcg-transfer-active-pane svg .js-rcg-transfer-animation-path');
        animationPathsActive.forEach(function (element) { return element.parentNode.removeChild(element); });
    };
    RcgTransfer.prototype.reload = function () {
        this.chargeFilterNoResultElement.hidden = true;
        this.chargeFilter.reset();
        this.transferService.filterByCharge([]);
        this.switchNetwork(Transfer_1.Network.All);
        this.hideContactUs();
        this.showIntroColumn();
        this.pushHistoryState();
    };
    RcgTransfer.prototype.reloadWithCharge = function (charge) {
        this.transferService.filterByCharge(charge);
        this.stationsAll = this.transferService.getStations();
        this.stationsInNetwork = this.transferService.getStations(this.network);
        this.networkLatLngsAll = this.transferService.getNetworkLatLngs();
        this.networkLatLngsInNetwork = this.transferService.getNetworkLatLngs(this.network);
        this.clearNetworkLayer();
        this.renderNetwork();
        this.renderStations();
        this.renderLocations();
        this.arrangeLayers();
        this.stopAnimation();
        if (this.isFullVersion)
            this.startAnimation();
        if (this.transferService.getTransfers().length === 0 && this.chargeFilter.isFilteringActive()) {
            this.chargeFilterNoResultElement.hidden = false;
            this.hideIntroColumn();
            this.hideContentColumn();
            this.showContactUs();
        }
        else {
            this.chargeFilterNoResultElement.hidden = true;
        }
        var stationData = this.stationsAll.concat([RcgTransfer.individualWaypoint]);
        this.inputFromAutocomplete.setData(stationData);
    };
    RcgTransfer.prototype.clearNetworkLayer = function () {
        this.networkLayer.clearLayers();
        this.stationsLayer.clearLayers();
    };
    RcgTransfer.prototype.clearActiveTransferLayers = function () {
        this.connectionStopsLayer.clearLayers();
        this.connectionLinesLayer.clearLayers();
    };
    RcgTransfer.prototype.clearLocationsLayer = function () {
        this.locationsLayer.clearLayers();
    };
    RcgTransfer.prototype.hideContentColumn = function () {
        this.contentColumn.hidden = true;
    };
    RcgTransfer.prototype.showContentColumn = function () {
        this.contentColumn.hidden = false;
    };
    RcgTransfer.prototype.hideContactUs = function () {
        if (!this.contactUs)
            return;
        this.contactUs.hidden = true;
    };
    RcgTransfer.prototype.showContactUs = function () {
        if (!this.contactUs)
            return;
        this.contactUs.hidden = false;
    };
    RcgTransfer.prototype.hideIntroColumn = function () {
        this.introColumn.hidden = true;
    };
    RcgTransfer.prototype.showIntroColumn = function () {
        this.introColumn.hidden = false;
    };
    RcgTransfer.prototype.clearContentColumn = function () {
        this.contentColumn.innerHTML = '';
    };
    // private clearTitle() {
    // 	this.title.textContent = this.titleInitialText;
    // 	this.title.classList.add('rcg-transfer__title--initial');
    // }
    RcgTransfer.prototype.getTransferTitleToUrlPart = function (transferTitle) {
        var _a = this.transferService.getTransferNormalizedTitle(transferTitle), normalizedTitle = _a.normalizedTitle, normalizedTitleSuffix = _a.normalizedTitleSuffix;
        return this.transferService.combineTransferTitleWithSuffix(normalizedTitle, normalizedTitleSuffix);
    };
    RcgTransfer.prototype.getStationActiveTooltipContent = function (station) {
        var location = this.transferService.getLocationByLatLng(station.latitude, station.longitude);
        var content = document.createElement('div');
        var title = document.createElement('span');
        title.textContent = station.title;
        content.appendChild(title);
        if (!location)
            return content;
        for (var _i = 0, _a = location.types; _i < _a.length; _i++) {
            var type = _a[_i];
            var link = this.getLocationTypeLink(location, type);
            content.appendChild(link);
        }
        return content;
    };
    RcgTransfer.prototype.getStationActiveTooltipOptions = function (station, firstOrLastStation, color, cssClasses) {
        if (cssClasses === void 0) { cssClasses = 'rcg-transfer-station-active-tooltip'; }
        return {
            direction: station.tooltipDirection,
            offset: this.getTooltipOffset(station),
            permanent: firstOrLastStation ? true : (this.isFullVersion ? false : true),
            opacity: firstOrLastStation ? 1 : 0.9,
            className: firstOrLastStation ? "".concat(cssClasses).concat(color ? " rcg-transfer-station-active-tooltip--".concat(color) : '') : 'rcg-transfer-station-tooltip',
            interactive: true,
        };
    };
    RcgTransfer.prototype.getLocationTypeLink = function (location, type) {
        var _this = this;
        var link = document.createElement('a');
        link.innerHTML = "<span class=\"screen-reader-text\">".concat(this.i18n['railcargo.transfer.locations.' + type], "</span>"); // icon(type);
        // link.href = '#location-' + i + '-' + type; // location.name + '-' + type;
        link.href = '#location-' + location.title + '-' + type;
        link.classList.add('rcg-transfer-location-marker-link');
        link.classList.add('rcg-transfer-location-marker-link--' + type);
        link.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this.renderLocationInformation(location, type);
        });
        return link;
    };
    RcgTransfer.prototype.getLocationMarkerIcon = function (types) {
        if (types.length > 1) {
            return RcgTransfer.markerStationGeneralMultiple;
        }
        var type = types[0];
        switch (type) {
            case Location_1.LocationType.Terminal:
                return RcgTransfer.markerStationGeneralTerminal;
            case Location_1.LocationType.Habor:
                return RcgTransfer.markerStationGeneralHabor;
            case Location_1.LocationType.Warehouse:
                return RcgTransfer.markerStationGeneralWarehouse;
            case Location_1.LocationType.Railway:
                return RcgTransfer.markerStationGeneral;
        }
    };
    RcgTransfer.prototype.getTooltipOffset = function (waypoint) {
        switch (waypoint.tooltipDirection) {
            case 'top':
                return new L.Point(0, -5);
            case 'auto':
            case 'right':
                return new L.Point(5, 0);
            case 'bottom':
                return new L.Point(0, 5);
            case 'left':
                return new L.Point(-5, 0);
            case 'center':
                break;
        }
        return new L.Point(0, 0);
    };
    RcgTransfer.prototype.getConnectionTitle = function (connection, withIcon) {
        if (withIcon === void 0) { withIcon = false; }
        if (connection.stationFrom == Transfer_1.individual || connection.stationTo == Transfer_1.individual)
            return connection.transfers[0].title;
        var icon = "<span class=\"ic-arrow2-right rcg-transfer__transfer-title--delimiter\" aria-hidden=\"true\"></span>";
        if ((!connection.stationFrom || !connection.stationTo) && withIcon)
            return connection.transfers[0].title.split('–').join(" ".concat(icon, " "));
        if (!connection.stationFrom || !connection.stationTo)
            return connection.transfers[0].title;
        if (withIcon)
            return "".concat(connection.stationFrom, " ").concat(icon, " ").concat(connection.stationTo);
        return "".concat(connection.stationFrom, "-").concat(connection.stationTo);
    };
    RcgTransfer.prototype.scrollToElement = function (el, force) {
        if (force === void 0) { force = true; }
        var rect = el.getBoundingClientRect();
        var elPos = (window.pageYOffset + rect.top) - RcgTransfer.scrollMargin;
        if (!force && window.pageYOffset > elPos)
            return;
        window.scrollTo({
            top: elPos,
            behavior: 'smooth',
        });
    };
    RcgTransfer.prototype.fitBoundsToConnection = function (timeout) {
        var _this = this;
        if (timeout === void 0) { timeout = 0; }
        setTimeout(function () {
            if (!_this.isFullVersion) {
                _this.map.fitBounds(_this.connectionLinesLayer.getBounds(), RcgTransfer.boundOptionsMobile);
            }
            else {
                _this.map.fitBounds(_this.connectionLinesLayer.getBounds(), RcgTransfer.boundOptions);
            }
        }, timeout);
    };
    RcgTransfer.prototype.renderNetwork = function () {
        // const networkLatLngs: L.LatLngExpression[][] = this.networkLatLngsInNetwork;
        // for (const polylineLatLngs of networkLatLngs) {
        // 	this.networkLayer.addLayer(
        // 		L.polyline(polylineLatLngs, { color: '#4c4c4c' })
        // 	);
        // }
        var networkLatLngs = (this.network == Transfer_1.Network.All) ? this.networkLatLngsAll : this.networkLatLngsInNetwork;
        var networkLatLngsContext = (this.network == Transfer_1.Network.All) ? this.transferService.getNetworkLatLngsContext() : this.transferService.getNetworkLatLngsContext(this.network);
        var lines = [];
        for (var i = 0; i < networkLatLngs.length; i++) {
            if (networkLatLngsContext[i]) {
                lines.push(L.polyline(networkLatLngs[i], { pane: 'rcg-transfer-network', color: networkLatLngsContext[i].network, weight: 4 }));
            }
            else {
                this.networkLayer.addLayer(L.polyline(networkLatLngs[i], { pane: 'rcg-transfer-network', color: '#4c4c4c' }));
            }
        }
        for (var _i = 0, lines_1 = lines; _i < lines_1.length; _i++) {
            var line = lines_1[_i];
            this.networkLayer.addLayer(line);
        }
    };
    RcgTransfer.prototype.renderStations = function () {
        var that = this;
        var stations = (this.network == Transfer_1.Network.All) ? this.stationsAll : this.stationsInNetwork;
        // let stations: Waypoint[] = this.stationsInNetwork;
        this.stationMarkers = [];
        var _loop_1 = function (station) {
            var tooltipDirection = station.tooltipDirection;
            var tooltipOffset = L.point(0, 0);
            var tooltipPermanent = station.tooltipPermanent;
            if (station.title == 'Vienna') {
                tooltipDirection = 'left';
                tooltipOffset = L.point(5, -10);
                tooltipPermanent = true;
            }
            else if (tooltipDirection == 'top') {
                tooltipOffset = L.point(0, 7);
            }
            else if (tooltipDirection == 'bottom') {
                tooltipOffset = L.point(0, -7);
            }
            // const marker: L.Marker = L.circleMarker(
            // 	[station.latitude, station.longitude],
            // 	RcgTransfer.markerOptions['station-general']
            // );
            var marker = L
                .marker([station.latitude, station.longitude], { icon: RcgTransfer.markerStationGeneral })
                .bindTooltip("".concat(station.title), {
                pane: 'rcg-transfer-station-tooltip',
                direction: tooltipDirection,
                offset: tooltipOffset,
                permanent: tooltipPermanent,
                className: "rcg-transfer-station-tooltip ".concat(tooltipPermanent ? 'js-rcg-transfer-station-tooltip-permanent' : ''),
            })
                .on('mouseover', function () {
                // this.setStyle({ color: RcgTransfer.markerOptions['station-general-active'].color });
                this.setIcon(RcgTransfer.markerStationActive);
            })
                .on('mouseout', function () {
                // this.setStyle({ color: RcgTransfer.markerOptions['station-general'].color });
                this.setIcon(RcgTransfer.markerStationGeneral);
            })
                .on('click', function () {
                that.handleStationMarkerClick(station);
                // this.setStyle({ color: RcgTransfer.markerOptions['station-general'].color });
                this.setIcon(RcgTransfer.markerStationGeneral);
            });
            this_1.stationMarkers.push(marker);
            this_1.stationsLayer.addLayer(marker);
        };
        var this_1 = this;
        for (var _i = 0, stations_1 = stations; _i < stations_1.length; _i++) {
            var station = stations_1[_i];
            _loop_1(station);
        }
    };
    RcgTransfer.prototype.renderLocations = function () {
        var that = this;
        // this.locations = this.transferService.getLocations();
        this.locations = this.transferService.getLocationsGroupedByLatLng();
        // for (const location of this.locations) {
        for (var i = 0; i < this.locations.length; i++) {
            var location_1 = this.locations[i];
            var locationMarkerContent = document.createElement('div');
            var locationTypes = [];
            locationMarkerContent.classList.add('rcg-transfer-location-marker__content');
            for (var _i = 0, _a = location_1.types; _i < _a.length; _i++) {
                var type = _a[_i];
                if (this.locationFilterOptions.indexOf(type) == -1)
                    continue;
                locationTypes.push(type);
                locationMarkerContent.appendChild(this.getLocationTypeLink(location_1, type));
            }
            if (locationTypes.length == 0)
                continue;
            if (locationTypes.length > 2) {
                var counter = document.createElement('span');
                counter.classList.add('rcg-transfer-location-marker__count');
                counter.textContent = locationTypes.length.toString();
                locationMarkerContent.classList.add('rcg-transfer-location-marker__content--more');
                locationMarkerContent.appendChild(counter);
            }
            // this.locationsLayer.addLayer(
            // 	new L.Marker(
            // 		[location.latitude, location.longitude],
            // 		{
            // 			icon: new L.DivIcon({
            // 				html: locationMarkerContent,
            // 				className: 'rcg-transfer-location-marker',
            // 				iconSize: null,
            // 			}),
            // 		}
            // 	)
            // );
            this.locationsLayer.addLayer(new L.Marker([location_1.latitude, location_1.longitude], {
                icon: this.getLocationMarkerIcon(locationTypes),
            })
                .on('click', function () {
                var locationStation = that.transferService.getStationByLatLng(this.getLatLng()['lat'], this.getLatLng()['lng']);
                if (locationStation)
                    that.handleStationMarkerClick(locationStation);
            })
                .bindPopup(locationMarkerContent, {
                minWidth: 25,
                maxWidth: 28,
                offset: new L.Point(-8, 0),
                className: 'rcg-transfer-location-popup',
            }));
        }
    };
    RcgTransfer.prototype.renderPossibleTransfers = function (stationFrom, transfers, network, possibleStationsByFromStation) {
        var _this = this;
        if (possibleStationsByFromStation === void 0) { possibleStationsByFromStation = []; }
        for (var _i = 0, transfers_2 = transfers; _i < transfers_2.length; _i++) {
            var transfer = transfers_2[_i];
            if (network &&
                (transfer.network != network
                    && transfer.networks.indexOf(network) === -1)) {
                continue;
            }
            var connectionLatLngs = [];
            var stations = [];
            for (var _a = 0, _b = transfer.route; _a < _b.length; _a++) {
                var waypoint = _b[_a];
                if (waypoint.type == Transfer_1.WaypointType.Station) {
                    if (possibleStationsByFromStation.length > 0) {
                        if (possibleStationsByFromStation.indexOf(waypoint.title) > -1)
                            stations.push(waypoint);
                    }
                    else {
                        stations.push(waypoint);
                    }
                }
                connectionLatLngs.push([waypoint.latitude, waypoint.longitude]);
            }
            this.connectionLinesLayer.addLayer(L.polyline(connectionLatLngs, { pane: 'rcg-transfer-active', color: (transfer.color ? transfer.color.active : '#e2002a'), weight: 4 }));
            var _loop_2 = function (station) {
                if (station.title == stationFrom)
                    return "continue";
                // const marker: L.CircleMarker = L.circleMarker(
                // 	[station.latitude, station.longitude],
                // 	RcgTransfer.markerOptions['station-general-possible'],
                // )
                var marker = L.marker([station.latitude, station.longitude], { icon: RcgTransfer.markerStationPossible })
                    .on('mouseover', function () {
                    // this.setStyle({ color: RcgTransfer.markerOptions['station-general-active'].color });
                    this.setIcon(RcgTransfer.markerStationPossibleActive);
                })
                    .on('mouseout', function () {
                    // this.setStyle({ color: RcgTransfer.markerOptions['station-general-possible'].color });
                    this.setIcon(RcgTransfer.markerStationPossible);
                })
                    .on('click', function () {
                    _this.handleStationMarkerClick(station);
                });
                this_2.connectionStopsLayer.addLayer(marker);
            };
            var this_2 = this;
            for (var _c = 0, stations_2 = stations; _c < stations_2.length; _c++) {
                var station = stations_2[_c];
                _loop_2(station);
            }
        }
        this.arrangeLayers();
    };
    RcgTransfer.prototype.renderTransfer = function (transfer, activeLabels) {
        if (activeLabels === void 0) { activeLabels = []; }
        var connectionLatLngs = [];
        var stations = [];
        for (var _i = 0, _a = transfer.route; _i < _a.length; _i++) {
            var waypoint = _a[_i];
            if (waypoint.type == Transfer_1.WaypointType.Station)
                stations.push(waypoint);
            connectionLatLngs.push([waypoint.latitude, waypoint.longitude]);
        }
        this.connectionLinesLayer.addLayer(L.polyline(connectionLatLngs, { pane: 'rcg-transfer-active', color: (transfer.color ? transfer.color.active : '#e2002a'), weight: 4 }));
        var stationCounter = 0;
        for (var _b = 0, stations_3 = stations; _b < stations_3.length; _b++) {
            var station = stations_3[_b];
            var firstOrLastStation = (stationCounter == 0 || stationCounter == (stations.length - 1));
            // const marker: L.CircleMarker = L.circleMarker(
            // 	[station.latitude, station.longitude],
            // 	RcgTransfer.markerOptions['station-general-active'],
            // );
            var marker = L.marker([station.latitude, station.longitude], { icon: RcgTransfer.markerStationActive });
            if (activeLabels.indexOf(station.title) == -1) {
                marker.bindTooltip(this.getStationActiveTooltipContent(station), this.getStationActiveTooltipOptions(station, firstOrLastStation, transfer.color ? transfer.color.active : null));
                if (firstOrLastStation) {
                    activeLabels.push(station.title);
                }
            }
            this.connectionStopsLayer.addLayer(marker);
            stationCounter++;
        }
    };
    RcgTransfer.prototype.renderConnection = function (connection) {
        var _a;
        var activeLabels = [];
        if (!connection.combinationReference) { // Single connection, can have more than one transfer objects (even it is the same transfer, because of different routes) like "Rotterdam - Wolfurt", so we draw all of them
            for (var _i = 0, _b = connection.transfers; _i < _b.length; _i++) {
                var transfer = _b[_i];
                var connectionLatLngs = [];
                var stations = [];
                var route = transfer.route;
                var stationFromIndex = -1;
                var stationToIndex = -1;
                var foundFrom = false;
                var foundTo = false;
                var secondRun = false;
                for (var i = 0; i < route.length; i++) {
                    if (route[i].title == connection.stationFrom)
                        stationFromIndex = i;
                    if (route[i].title == connection.stationTo)
                        stationToIndex = i;
                    if (stationFromIndex > -1 && stationToIndex > -1)
                        break;
                }
                if (stationFromIndex > stationToIndex && !transfer.isOneWay)
                    route.reverse();
                for (var i = 0; i < route.length; i++) {
                    if (route[i].title == connection.stationFrom)
                        foundFrom = true;
                    if (foundFrom) {
                        if (route[i].type == Transfer_1.WaypointType.Station)
                            stations.push(route[i]);
                        connectionLatLngs.push([route[i].latitude, route[i].longitude]);
                    }
                    if (foundFrom && route[i].title == connection.stationTo)
                        foundTo = true;
                    if (foundFrom && foundTo)
                        break;
                    // If we found from-station but not a to-station and reached the end of the waypoints, we iterate the route again
                    if (foundFrom && !foundTo && (i + 1) == route.length) {
                        // If it is the last waypoint and the second run, just break to prevent loop
                        if (!secondRun) {
                            secondRun = true;
                            i = 0;
                        }
                        else {
                            break;
                        }
                    }
                }
                this.connectionLinesLayer.addLayer(L.polyline(connectionLatLngs, { pane: 'rcg-transfer-active', color: (transfer.color ? transfer.color.active : '#e2002a'), weight: 4 }));
                var stationCounter = 0;
                for (var _c = 0, stations_4 = stations; _c < stations_4.length; _c++) {
                    var station = stations_4[_c];
                    var firstOrLastStation = (stationCounter == 0 || stationCounter == (stations.length - 1));
                    // const marker: L.CircleMarker = L.circleMarker(
                    // 	[station.latitude, station.longitude],
                    // 	RcgTransfer.markerOptions['station-general-active'],
                    // );
                    var marker = L.marker([station.latitude, station.longitude], { icon: RcgTransfer.markerStationActive });
                    if (activeLabels.indexOf(station.title) == -1) {
                        marker.bindTooltip(this.getStationActiveTooltipContent(station), this.getStationActiveTooltipOptions(station, firstOrLastStation, transfer.color ? transfer.color.active : null));
                        if (firstOrLastStation) {
                            activeLabels.push(station.title);
                        }
                    }
                    this.connectionStopsLayer.addLayer(marker);
                    stationCounter++;
                }
            }
            if (connection.transfers[0].isNonStandardConnection) {
                this.pushHistoryState();
                this.setTransferInDropdown();
            }
            else {
                this.pushHistoryState(this.transferService.getTransferTitleWithSuffix(connection.transfers[0]), 'transfer');
                this.setTransferInDropdown(connection.transfers[0]);
            }
        }
        else { // Combined connection
            var stations = [];
            var stationColors = [];
            var routeInformation = [];
            var linkStation = void 0;
            for (var i = 0; i < connection.transfers.length; i++) {
                var transfer = connection.transfers[i];
                var combinationForVia = connection.reversed ? connection.combinationReference[(i + 1)] : connection.combinationReference[i];
                var connectionLatLngs = [];
                var route = transfer.route;
                var stationFrom = void 0;
                var stationFromIndex = -1;
                var stationTo = void 0;
                var stationToIndex = -1;
                if (i == 0) { // First
                    stationFrom = connection.stationFrom;
                    if (combinationForVia.via) {
                        stationTo = combinationForVia.via;
                    }
                    else {
                        currentRouteLoop: for (var _d = 0, route_1 = route; _d < route_1.length; _d++) {
                            var waypoint = route_1[_d];
                            if (waypoint.type != Transfer_1.WaypointType.Station)
                                continue currentRouteLoop;
                            nextRouteLoop: for (var _e = 0, _f = connection.transfers[i + 1].route; _e < _f.length; _e++) {
                                var nextWaypoint = _f[_e];
                                if (nextWaypoint.type != Transfer_1.WaypointType.Station)
                                    continue nextRouteLoop;
                                if (nextWaypoint.title == waypoint.title) {
                                    stationTo = waypoint.title;
                                    break currentRouteLoop;
                                }
                            }
                        }
                    }
                    linkStation = stationTo;
                }
                else if (i == (connection.transfers.length - 1)) { // Last
                    stationFrom = linkStation;
                    stationTo = connection.stationTo;
                }
                else { // Between
                    stationFrom = linkStation;
                    if (combinationForVia.via) {
                        stationTo = combinationForVia.via;
                    }
                    else {
                        currentRouteLoop: for (var _g = 0, route_2 = route; _g < route_2.length; _g++) {
                            var waypoint = route_2[_g];
                            if (waypoint.type != Transfer_1.WaypointType.Station)
                                continue currentRouteLoop;
                            nextRouteLoop: for (var _h = 0, _j = connection.transfers[i + 1].route; _h < _j.length; _h++) {
                                var nextWaypoint = _j[_h];
                                if (nextWaypoint.type != Transfer_1.WaypointType.Station)
                                    continue nextRouteLoop;
                                if (nextWaypoint.title == waypoint.title) {
                                    stationTo = waypoint.title;
                                    break currentRouteLoop;
                                }
                            }
                        }
                    }
                    linkStation = stationTo;
                }
                for (var i_1 = 0; i_1 < route.length; i_1++) {
                    if (route[i_1].title == stationFrom)
                        stationFromIndex = i_1;
                    if (route[i_1].title == stationTo)
                        stationToIndex = i_1;
                    if (stationFromIndex > -1 && stationToIndex > -1)
                        break;
                }
                if (stationFromIndex > stationToIndex) {
                    _a = [stationToIndex, stationFromIndex], stationFromIndex = _a[0], stationToIndex = _a[1];
                }
                // Generate route information
                if ((i == 0 && stationFrom == route[stationFromIndex].title)
                    || (i == (connection.transfers.length - 1) && stationTo == route[stationToIndex].title)) {
                    if (routeInformation.indexOf(route[stationFromIndex].title) == -1)
                        routeInformation.push(route[stationFromIndex].title);
                    if (routeInformation.indexOf(route[stationToIndex].title) == -1)
                        routeInformation.push(route[stationToIndex].title);
                }
                else {
                    if (routeInformation[routeInformation.length - 1] == route[stationFromIndex].title) {
                        if (routeInformation.indexOf(route[stationFromIndex].title) == -1)
                            routeInformation.push(route[stationFromIndex].title);
                        if (routeInformation.indexOf(route[stationToIndex].title) == -1)
                            routeInformation.push(route[stationToIndex].title);
                    }
                    else {
                        if (routeInformation.indexOf(route[stationToIndex].title) == -1)
                            routeInformation.push(route[stationToIndex].title);
                        if (routeInformation.indexOf(route[stationFromIndex].title) == -1)
                            routeInformation.push(route[stationFromIndex].title);
                    }
                }
                for (var j = stationFromIndex; j < route.length; j++) {
                    connectionLatLngs.push([route[j].latitude, route[j].longitude]);
                    if (route[j].type == Transfer_1.WaypointType.Station)
                        stations.push(route[j]);
                    if (route[j].type == Transfer_1.WaypointType.Station && transfer.color)
                        stationColors.push({ station: route[j].title, color: transfer.color ? transfer.color.name : null });
                    if (j == stationToIndex)
                        break;
                }
                this.connectionLinesLayer.addLayer(L.polyline(connectionLatLngs, { pane: 'rcg-transfer-active', color: (transfer.color ? transfer.color.active : '#e2002a'), weight: 4 }));
            }
            connection.route = routeInformation;
            for (var _k = 0, stations_5 = stations; _k < stations_5.length; _k++) {
                var waypoint = stations_5[_k];
                var firstOrLastStation = (waypoint.title == connection.stationFrom || waypoint.title == connection.stationTo);
                var marker = L.marker([waypoint.latitude, waypoint.longitude], { icon: RcgTransfer.markerStationActiveCombination });
                var color = null;
                for (var _l = 0, stationColors_1 = stationColors; _l < stationColors_1.length; _l++) {
                    var stationColor = stationColors_1[_l];
                    if (stationColor.station == waypoint.title) {
                        color = stationColor.color;
                        break;
                    }
                }
                marker.bindTooltip(this.getStationActiveTooltipContent(waypoint), this.getStationActiveTooltipOptions(waypoint, firstOrLastStation, color, "rcg-transfer-station-active-tooltip rcg-transfer-station-active-tooltip--combination"));
                this.connectionStopsLayer.addLayer(marker);
            }
            this.setTransferInDropdown();
            this.pushHistoryState(connection.combinationName, 'combination');
        }
    };
    RcgTransfer.prototype.renderAdvantages = function (advantages) {
        var advantagesContent = '<ul class="rcg-transfer__list">';
        for (var _i = 0, advantages_1 = advantages; _i < advantages_1.length; _i++) {
            var advantage = advantages_1[_i];
            advantagesContent += "\n\t\t\t\t<li>".concat(advantage, "</li>\n\t\t\t");
        }
        advantagesContent += '</ul>';
        return advantagesContent;
    };
    ;
    RcgTransfer.prototype.renderContacts = function (contacts) {
        var contentContacts = '';
        for (var _i = 0, contacts_1 = contacts; _i < contacts_1.length; _i++) {
            var contact = contacts_1[_i];
            contentContacts += "\n\t\t\t\t<div class=\"col-2\">\n\t\t\t\t\t<p>\n\t\t\t\t\t\t<span class=\"rcg-transfer__txt-highlight\">".concat(contact.name, "</span><br/>\n\t\t\t\t\t\t").concat(contact.department
                ? contact.department + '<br />'
                : '', "\n\t\t\t\t\t\t").concat(contact.phone
                ? '<a href="tel:' + contact.phone + '">' + contact.phone + '</a><br/>'
                : '', "\n\t\t\t\t\t\t").concat(contact.email
                ? '<a href="mailto:' + contact.email + '" class="md-button">'
                    + '<span aria-hidden="true" class="ic-mail1"></span>'
                    + this.i18n['railcargo.transfer.contact.sendMail']
                : '', "\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t");
        }
        return contentContacts;
    };
    ;
    RcgTransfer.prototype.renderFurtherInformation = function (transfer, isCombination, chargeOverride) {
        var _this = this;
        if (isCombination === void 0) { isCombination = false; }
        var charge;
        if (chargeOverride && chargeOverride.length > 0) {
            this.transferService.sortCharge(chargeOverride);
            charge = chargeOverride.map(function (charge) { return _this.i18n['railcargo.transfer.charge.' + charge]; }).join(', ');
        }
        else {
            if (transfer.charge) {
                this.transferService.sortCharge(transfer.charge);
                charge = transfer.charge.map(function (charge) { return _this.i18n['railcargo.transfer.charge.' + charge]; }).join(', ');
            }
            else {
                charge = transfer.furtherInformation.charge;
            }
        }
        return "\n\t\t\t<h3 class=\"rcg-transfer__transfer-headline\">".concat(this.i18n['railcargo.transfer.furtherInformation.title'], "</h3>\n\t\t\t<dl>\n\t\t\t\t").concat(charge ? "\n\t\t\t\t\t<div>\n\t\t\t\t\t\t<dt class=\"rcg-transfer__txt-highlight\">".concat(this.i18n['railcargo.transfer.furtherInformation.charge'], ":</dt>\n\t\t\t\t\t\t<dd>").concat(charge, "</dd>\n\t\t\t\t\t</div>\n\t\t\t\t") : '', "\n\t\t\t\t").concat(transfer.furtherInformation.RID ? "\n\t\t\t\t\t<div>\n\t\t\t\t\t\t<dt class=\"rcg-transfer__txt-highlight\">RID:</dt>\n\t\t\t\t\t\t<dd>".concat(transfer.furtherInformation.RID, "</dd>\n\t\t\t\t\t</div>\n\t\t\t\t") : '', "\n\t\t\t\t").concat(!isCombination && transfer.furtherInformation.frequency ? "\n\t\t\t\t\t<div>\n\t\t\t\t\t\t<dt class=\"rcg-transfer__txt-highlight\">".concat(this.i18n['railcargo.transfer.furtherInformation.frequency'], ":</dt>\n\t\t\t\t\t\t<dd>").concat(transfer.furtherInformation.frequency, "</dd>\n\t\t\t\t\t</div>\n\t\t\t\t") : '', "\n\t\t\t\t").concat(transfer.furtherInformation.duration ? "\n\t\t\t\t\t<div>\n\t\t\t\t\t\t<dt class=\"rcg-transfer__txt-highlight\">".concat(this.i18n['railcargo.transfer.furtherInformation.duration'], ":</dt>\n\t\t\t\t\t\t<dd>").concat(transfer.furtherInformation.duration, "</dd>\n\t\t\t\t\t</div>\n\t\t\t\t") : '', "\n\t\t\t\t").concat(!isCombination && transfer.furtherInformation.route ? "\n\t\t\t\t\t<div>\n\t\t\t\t\t\t<dt class=\"rcg-transfer__txt-highlight\">".concat(this.i18n['railcargo.transfer.furtherInformation.route'], ":</dt>\n\t\t\t\t\t\t<dd>").concat(transfer.furtherInformation.route, "</dd>\n\t\t\t\t\t</div>\n\t\t\t\t") : '', "\n\t\t\t</dl>\n\t\t");
    };
    RcgTransfer.prototype.renderLinks = function (links) {
        var contentLinks = '';
        for (var _i = 0, links_1 = links; _i < links_1.length; _i++) {
            var link = links_1[_i];
            var type = link.type;
            if (link.href.slice(-4) == '.pdf' || link.href.indexOf('/dms/') > -1)
                type = 'download';
            contentLinks += "\n\t\t\t\t<a\n\t\t\t\t\thref=\"".concat(link.href, "\"\n\t\t\t\t\tclass=\"md-button\"\n\t\t\t\t\t").concat(link.target ? "target=\"".concat(link.target, "\"") : '', "\n\t\t\t\t\t").concat(link.title ? "title=\"".concat(link.title, "\"") : '', "\n\t\t\t\t\t").concat(link.download ? 'download' : '', "\n\t\t\t\t\t").concat(type == 'overlay' ? "data-overlay-title=\"".concat(link.title ? link.title : '', "\" data-overlay-url=\"").concat(link.href, "\"") : '', "\n\t\t\t\t>\n\t\t\t\t\t").concat(type == 'download' ? "<span aria-hidden=\"true\" class=\"ic-download\"></span>" : '', "\n\t\t\t\t\t").concat(type == 'external' ? "<span aria-hidden=\"true\" class=\"ic-arrow4-right\"></span>" : '', "\n\t\t\t\t\t").concat(link.text, "\n\t\t\t\t\t").concat(type == 'page' ? "<span aria-hidden=\"true\" class=\"ic-arrow2-right\"></span>" : '', "\n\t\t\t\t</a><br />\n\t\t\t");
        }
        return contentLinks;
    };
    RcgTransfer.prototype.renderEmissionChart = function (transfer) {
        var content = '';
        if (!(transfer.emission && transfer.emission.rail && transfer.emission.street))
            return content;
        EmissionChartGenerator_1.EmissionChartGenerator.locale = this.transferService.getLocale();
        return "\n\t\t\t<h3 class=\"rcg-transfer__transfer-headline\" id=\"rcg-transfer-emission-chart-title\">".concat(this.i18n['railcargo.transfer.emission.title'], "</h3>\n\t\t\t").concat(EmissionChartGenerator_1.EmissionChartGenerator.generate({
            rail: transfer.emission.rail,
            street: transfer.emission.street,
        }), "\n\t\t\t<p id=\"id=\"rcg-transfer-emission-chart-description\">\n\t\t\t\t").concat(EmissionChartGenerator_1.EmissionChartGenerator.generateLegendIcon('rail'), " ").concat(this.i18n['railcargo.transfer.emission.rail'], " ").concat(transfer.emission.rail.toLocaleString(this.transferService.getLocale()), " ").concat(this.i18n['railcargo.transfer.emission.unit'], "<br />\n\t\t\t\t").concat(EmissionChartGenerator_1.EmissionChartGenerator.generateLegendIcon('street'), " ").concat(this.i18n['railcargo.transfer.emission.street'], " ").concat(transfer.emission.street.toLocaleString(this.transferService.getLocale()), " ").concat(this.i18n['railcargo.transfer.emission.unit'], "<br /><br />\n\t\t\t\t").concat(this.i18n['railcargo.transfer.emission.meta'], "\n\t\t\t</p>\n\t\t");
    };
    RcgTransfer.prototype.renderConnectionInformation = function (connection, withContentColumn) {
        if (withContentColumn === void 0) { withContentColumn = true; }
        if (this.mapElement.hidden) {
            this.mapElement.hidden = false;
            this.map.invalidateSize();
        }
        if (connection.stationFrom == Transfer_1.individual || connection.stationTo == Transfer_1.individual) {
            if (!this.isFullVersion)
                this.mapElement.hidden = true;
            connection.transfers[0].title = this.i18n['railcargo.transfer.fromToIndividual'];
        }
        if (this.breadcrumbList) {
            var breadcrumbListItems = this.breadcrumbList.querySelectorAll('li');
            var breadcrumbListItemLast = breadcrumbListItems.item(breadcrumbListItems.length - 1);
            var breadcrumbListItemTransfer = this.breadcrumbList.querySelector('.js-rcg-transfer-breadcrumb-transfer');
            if (!breadcrumbListItemTransfer) {
                breadcrumbListItemLast.querySelector('a').insertAdjacentHTML('beforeend', '<span class="ic-arrow2-right" aria-hidden="true"></span>');
                var breadcrumbTransferItem = document.createElement('li');
                breadcrumbTransferItem.classList.add('js-rcg-transfer-breadcrumb-transfer');
                breadcrumbTransferItem.textContent = connection.transfers[0].title;
                this.breadcrumbList.appendChild(breadcrumbTransferItem);
            }
            else {
                breadcrumbListItemTransfer.textContent = connection.transfers[0].title;
            }
        }
        // if (this.title.classList.contains('rcg-transfer__title--initial')) {
        // 	this.title.classList.remove('rcg-transfer__title--initial');
        // }
        // this.title.innerHTML = this.getConnectionTitle(connection, true);
        // if (connection.combinationReference) {
        // 	this.title.innerHTML += `
        // 		<span class="rcg-transfer__title-meta">
        // 			${this.i18n['railcargo.transfer.resultCombination']}
        // 			<span class="rcg-transfer__title-meta-type">(${this.i18n['railcargo.transfer.' + connection.transfers[0].network]})</span>
        // 		</span>`;
        // } else if (connection.stationFrom == individual && connection.stationTo == individual) {
        // 	this.title.innerHTML += `
        // 		<span class="rcg-transfer__title-meta">
        // 			${this.i18n['railcargo.transfer.name']}
        // 			${connection.transfers[0].title}
        // 		</span>`;
        // } else {
        // 	this.title.innerHTML += `
        // 		<span class="rcg-transfer__title-meta">
        // 			${this.i18n['railcargo.transfer.name']}
        // 			${connection.transfers[0].title}
        // 			<span class="rcg-transfer__title-meta-type">(${this.i18n['railcargo.transfer.' + connection.transfers[0].network]})</span>
        // 		</span>`;
        // }
        if (!withContentColumn) {
            return;
        }
        this.clearContentColumn();
        if (connection.stationFrom == Transfer_1.individual && connection.stationTo == Transfer_1.individual) {
            this.hideContentColumn();
            this.hideIntroColumn();
            this.showContactUs();
            (this.isFullVersion) ? this.scrollToElement(this.form, false) : this.scrollToElement(this.mapElement, false);
            return;
        }
        else {
            this.hideContactUs();
            this.hideIntroColumn(); // Keep hidden
            this.showContentColumn();
        }
        var content = '';
        if (!connection.combinationReference) {
            for (var i = 0; i < connection.transfers.length; i++) {
                var transfer = connection.transfers[i];
                var baseTransfer = this.transferService.getBaseTransfer(transfer);
                content += "\n\t\t\t\t\t<div class=\"rcg-transfer-content-section\">\n\t\t\t\t\t\t<div class=\"rcg-transfer-content__main\">\n\t\t\t\t\t\t\t".concat(i == 0 ? "<h2 class=\"rcg-transfer__transfer-title\">\n\t\t\t\t\t\t\t\t".concat(this.getConnectionTitle(connection, true), "\n\t\t\t\t\t\t\t</h2>") : '', "\n\n\t\t\t\t\t\t\t<p class=\"rcg-transfer__transfer-subtitle\">").concat(this.i18n['railcargo.transfer.name'], " ").concat(baseTransfer.title, "</p>\n\n\t\t\t\t\t\t\t").concat(baseTransfer.intro ? "<div>\n\t\t\t\t\t\t\t\t".concat(baseTransfer.intro, "\n\t\t\t\t\t\t\t</div>") : '', "\n\n\t\t\t\t\t\t\t").concat(baseTransfer.advantages.length > 0 ? "<div>\n\t\t\t\t\t\t\t\t<h3 class=\"rcg-transfer__transfer-headline\">".concat(this.i18n['railcargo.transfer.advantages'], "</h3>\n\t\t\t\t\t\t\t\t").concat(this.renderAdvantages(baseTransfer.advantages), "\n\t\t\t\t\t\t\t</div>") : '', "\n\n\t\t\t\t\t\t\t").concat(transfer.contacts.length > 0 ? "<div>\n\t\t\t\t\t\t\t\t<h3 class=\"rcg-transfer__transfer-headline\">".concat(this.i18n['railcargo.transfer.contact.title'], "</h3>\n\t\t\t\t\t\t\t\t<div class=\"row\">\n\t\t\t\t\t\t\t\t\t").concat(this.renderContacts(transfer.contacts), "\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>") : '', "\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t").concat((baseTransfer.contentLinks.length > 0
                    || baseTransfer.charge
                    || baseTransfer.furtherInformation.charge
                    || baseTransfer.furtherInformation.frequency
                    || baseTransfer.furtherInformation.duration
                    || baseTransfer.furtherInformation.route) ? "\n\t\t\t\t\t\t<div class=\"rcg-transfer-content__meta js-rcg-transfer-content-meta\">\n\t\t\t\t\t\t\t".concat(this.renderFurtherInformation(baseTransfer), "\n\n\t\t\t\t\t\t\t").concat(this.renderLinks(baseTransfer.contentLinks), "\n\n\t\t\t\t\t\t\t").concat(this.renderEmissionChart(baseTransfer), "\n\t\t\t\t\t\t</div>") : '', "\n\t\t\t\t\t</div>\n\t\t\t\t");
            }
        }
        else {
            var combination = this.transferService.getCombination(connection.combinationName);
            var transfer = void 0;
            var contacts = void 0;
            // Get first transfer for content, depending on the connection (direction); If the direction is reversed also the TransFERs and therefore the contact is reversed
            for (var _i = 0, _a = connection.transfers; _i < _a.length; _i++) {
                var connectionTransfer = _a[_i];
                if (!connectionTransfer.isNonStandardConnection) {
                    transfer = connectionTransfer;
                    contacts = connectionTransfer.contacts;
                    break;
                }
            }
            if (combination.contacts.length > 0) {
                contacts = combination.contacts;
            }
            var chargeOverride = this.transferService.getMatchingChargeFromTransfers(connection.transfers);
            var baseTransfer = void 0;
            if (!transfer) {
                console.warn('This should not happen and means that the combination consists only of non standard connections like parnter or EZW transfers or has no transfers at all.');
                baseTransfer = connection.transfers[0]; // We need a base transfer to render further information
            }
            else {
                baseTransfer = this.transferService.getBaseTransfer(transfer);
            }
            content += "\n\t\t\t\t<div class=\"rcg-transfer-content-section\">\n\t\t\t\t\t<div class=\"rcg-transfer-content__main\">\n\t\t\t\t\t\t<h2 class=\"rcg-transfer__transfer-title\">\n\t\t\t\t\t\t\t".concat(this.getConnectionTitle(connection, true), "\n\t\t\t\t\t\t</h2>\n\n\t\t\t\t\t\t<p class=\"rcg-transfer__transfer-subtitle\">\n\t\t\t\t\t\t\t").concat(this.i18n['railcargo.transfer.resultCombination'], "\n\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t<p class=\"rcg-transfer__transfer-combinaion-route\">").concat(connection.route.join(' - '), "</p>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t").concat(this.i18n['railcargo.transfer.combination.intro'], "\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t<h3 class=\"rcg-transfer__transfer-headline\">").concat(this.i18n['railcargo.transfer.advantages'], "</h3>\n\t\t\t\t\t\t\t").concat(this.renderAdvantages([
                this.i18n['railcargo.transfer.combination.advantage1'],
                this.i18n['railcargo.transfer.combination.advantage2'],
                this.i18n['railcargo.transfer.combination.advantage3'],
            ]), "\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t").concat((transfer === null || transfer === void 0 ? void 0 : transfer.contacts.length) > 0 || contacts ? "<div>\n\t\t\t\t\t\t\t<h3 class=\"rcg-transfer__transfer-headline\">".concat(this.i18n['railcargo.transfer.contact.title'], "</h3>\n\t\t\t\t\t\t\t<div class=\"row\">\n\t\t\t\t\t\t\t\t").concat(this.renderContacts(contacts), "\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>") : '', "\n\t\t\t\t\t</div>\n\n\t\t\t\t\t").concat((combination.contentLinks.length > 0
                || baseTransfer && (baseTransfer.charge
                    || baseTransfer.furtherInformation.charge
                    || baseTransfer.furtherInformation.frequency
                    || baseTransfer.furtherInformation.duration
                    || baseTransfer.furtherInformation.route)) ? "\n\t\t\t\t\t<div class=\"rcg-transfer-content__meta\">\n\t\t\t\t\t\t".concat(baseTransfer ? this.renderFurtherInformation(baseTransfer, true, chargeOverride) : '', "\n\n\t\t\t\t\t\t").concat(this.renderLinks(combination.contentLinks), "\n\t\t\t\t\t</div>") : '', "\n\t\t\t\t</div>\n\t\t\t");
        }
        this.contentColumn.innerHTML = content;
        (this.isFullVersion) ? this.scrollToElement(this.form, false) : this.scrollToElement(this.mapElement, false);
    };
    RcgTransfer.prototype.renderLocationInformation = function (locationGrouped, typeSelected) {
        if (this.mapElement.hidden) {
            this.mapElement.hidden = false;
            this.map.invalidateSize();
        }
        this.hideIntroColumn();
        this.hideContactUs();
        this.showContentColumn();
        // if (this.title.classList.contains('rcg-transfer__title--initial')) {
        // 	this.title.classList.remove('rcg-transfer__title--initial');
        // }
        // this.title.innerHTML = `
        // 	${locationGrouped.title}
        // 	<span class="rcg-transfer__title-meta">${this.i18n['railcargo.transfer.locations.' + typeSelected]}</span>
        // `;
        var content = '';
        for (var _i = 0, _a = locationGrouped.locations; _i < _a.length; _i++) {
            var location_2 = _a[_i];
            if (location_2.types.indexOf(typeSelected) == -1)
                continue;
            content += "\n\t\t\t\t<div class=\"rcg-transfer-content-section\">\n\t\t\t\t\t<div class=\"rcg-transfer-content__main\">\n\t\t\t\t\t\t<h2 class=\"rcg-transfer__transfer-title\">".concat(location_2.title, "</h2>\n\t\t\t\t\t\t<h3 class=\"rcg-transfer__transfer-subtitle\">").concat(this.i18n['railcargo.transfer.locations.' + typeSelected], "</h3>\n\t\t\t");
            if (typeSelected == 'station') {
                content += "\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t";
            }
            else {
                var locationForType = location_2[typeSelected];
                if (locationForType) {
                    content += "\n\t\t\t\t\t\t\t\t".concat(locationForType.text ? "<div>\n\t\t\t\t\t\t\t\t\t".concat(locationForType.text, "\n\t\t\t\t\t\t\t\t</div>") : '', "\n\n\t\t\t\t\t\t\t\t").concat(locationForType.contacts.length > 0 ? "<div>\n\t\t\t\t\t\t\t\t\t<h3 class=\"rcg-transfer__transfer-headline\">".concat(this.i18n['railcargo.transfer.contact.title'], "</h3>\n\t\t\t\t\t\t\t\t\t<div class=\"row\">\n\t\t\t\t\t\t\t\t\t\t").concat(this.renderContacts(locationForType.contacts), "\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>") : '', "\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class=\"rcg-transfer-content__meta x\">\n\t\t\t\t\t\t\t\t").concat(locationForType.operator ? "\n\t\t\t\t\t\t\t\t\t<h3 class=\"rcg-transfer__transfer-headline\">".concat(this.i18n['railcargo.transfer.location.operator'], "</h3>\n\n\t\t\t\t\t\t\t\t\t<p>").concat(locationForType.operator, "</p>\n\t\t\t\t\t\t\t\t") : '', "\n\n\t\t\t\t\t\t\t\t").concat(locationForType.address ? "\n\t\t\t\t\t\t\t\t\t<h3 class=\"rcg-transfer__transfer-headline\">".concat(this.i18n['railcargo.transfer.location.address'], "</h3>\n\n\t\t\t\t\t\t\t\t\t<p>").concat(locationForType.address.split(',').join("<br />"), "<p>\n\t\t\t\t\t\t\t\t") : '', "\n\n\t\t\t\t\t\t\t\t").concat(locationForType.link ? "\n\t\t\t\t\t\t\t\t\t".concat(this.renderLinks([locationForType.link]), "\n\t\t\t\t\t\t\t\t") : '', "\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t");
                }
                else {
                    content += "\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t";
                }
            }
        }
        this.contentColumn.innerHTML = content;
        (this.isFullVersion) ? this.scrollToElement(this.form, false) : this.scrollToElement(this.mapElement, false);
    };
    RcgTransfer.scrollMargin = 85;
    RcgTransfer.markerStationGeneral = new L.Icon({
        iconUrl: '/.resources/corp-2016/themes/images/rcg-transfer/marker-station-general.svg',
        iconSize: [18, 18],
        iconAnchor: [9, 9],
        popupAnchor: [9, 9],
    });
    RcgTransfer.markerStationGeneralTerminal = new L.Icon({
        iconUrl: '/.resources/corp-2016/themes/images/rcg-transfer/marker-station-general-terminal.svg',
        iconSize: [18, 18],
        iconAnchor: [9, 9],
        popupAnchor: [9, 9],
    });
    RcgTransfer.markerStationGeneralHabor = new L.Icon({
        iconUrl: '/.resources/corp-2016/themes/images/rcg-transfer/marker-station-general-habor.svg',
        iconSize: [18, 18],
        iconAnchor: [9, 9],
        popupAnchor: [9, 9],
    });
    RcgTransfer.markerStationGeneralWarehouse = new L.Icon({
        iconUrl: '/.resources/corp-2016/themes/images/rcg-transfer/marker-station-general-warehouse.svg',
        iconSize: [18, 18],
        iconAnchor: [9, 9],
        popupAnchor: [9, 9],
    });
    RcgTransfer.markerStationGeneralMultiple = new L.Icon({
        iconUrl: '/.resources/corp-2016/themes/images/rcg-transfer/marker-station-general-multiple.svg',
        iconSize: [18, 18],
        iconAnchor: [9, 9],
        popupAnchor: [9, 9],
    });
    RcgTransfer.markerStationActive = new L.Icon({
        iconUrl: '/.resources/corp-2016/themes/images/rcg-transfer/marker-station-active.svg',
        iconSize: [18, 18],
        iconAnchor: [9, 9],
        popupAnchor: [9, 9],
    });
    RcgTransfer.markerStationActiveCombination = new L.Icon({
        iconUrl: '/.resources/corp-2016/themes/images/rcg-transfer/marker-station-active-combination.svg',
        iconSize: [18, 18],
        iconAnchor: [9, 9],
        popupAnchor: [9, 9],
    });
    RcgTransfer.markerStationPossible = new L.Icon({
        iconUrl: '/.resources/corp-2016/themes/images/rcg-transfer/marker-station-possible.svg',
        iconSize: [14, 14],
        iconAnchor: [7, 7],
        popupAnchor: [7, 7],
    });
    RcgTransfer.markerStationPossibleActive = new L.Icon({
        iconUrl: '/.resources/corp-2016/themes/images/rcg-transfer/marker-station-possible-active.svg',
        iconSize: [14, 14],
        iconAnchor: [7, 7],
        popupAnchor: [7, 7],
    });
    RcgTransfer.mapOptions = {
        zoomControl: false,
        minZoom: 3.75,
        maxZoom: 6.5,
        zoomSnap: 0,
        zoomDelta: 0.25,
        // renderer: L.canvas({ tolerance: 3 }),
    };
    RcgTransfer.tooltipThreshold = 4.6;
    RcgTransfer.boundOptions = {
        paddingTopLeft: [150, 50],
        paddingBottomRight: [250, 100],
        maxZoom: 6,
    };
    RcgTransfer.boundOptionsMobile = {
        paddingTopLeft: [50, 75],
        paddingBottomRight: [30, 50],
    };
    RcgTransfer.latLngCenterAll = [48.50204750525715, 28.388671875000004];
    RcgTransfer.individualTransfer = {
        name: Transfer_1.individual,
        network: null,
        networks: null,
        route: null,
        intro: null,
        advantages: null,
        contacts: null,
        charge: null,
        furtherInformation: null,
        contentLinks: null,
    };
    RcgTransfer.individualWaypoint = {
        title: Transfer_1.individual,
        type: Transfer_1.WaypointType.Individual,
        latitude: 0,
        longitude: 0,
        tooltipDirection: 'auto',
        tooltipPermanent: false,
    };
    RcgTransfer.individualConnection = {
        stationFrom: Transfer_1.individual,
        stationTo: Transfer_1.individual,
        transfers: [RcgTransfer.individualTransfer],
    };
    RcgTransfer.animationOptions = {
        interval: 5000,
        concurrent: 6,
        trainLength: 15,
        trainSpeed: 8,
        trainAnimationDurationThreshold: 2000,
    };
    return RcgTransfer;
}(Leaflet_1.Leaflet));
exports.RcgTransfer = RcgTransfer;
function icon(id) {
    return "\n\t\t<svg viewBox=\"0 0 32 32\" class=\"rcg-transfer-icon\" aria-hidden=\"true\">\n\t\t\t<use href=\"#icon-".concat(id, "\"></use>\n\t\t</svg>\n\t");
}
function initTransferMap(module) {
    var chargeFilter = new ChargeFilter_1.ChargeFilter(document.querySelector('.js-rcg-transfer-charge-filter'));
    var breadcrumbList = document.querySelector('.breadcrumb .bc');
    var langNavList = document.querySelector('#langNavList');
    var contactUs = document.querySelector('.js-new-to-rcg');
    var i18nList = document.querySelector('.js-i18n-strings');
    var apiUrl = module.dataset.url;
    var transferService = new TransferService_1.TransferService(apiUrl, i18nList);
    var rcgTransfer = new RcgTransfer(module, transferService, chargeFilter);
    rcgTransfer.init(Transfer_1.Network.All, function () {
        rcgTransfer.setBreadcrumbList(breadcrumbList);
        rcgTransfer.setLangNavList(langNavList);
        rcgTransfer.setContactUs(contactUs);
        chargeFilter.init(transferService.getI18nStrings());
    });
    document.querySelector('#main').removeAttribute('tabindex');
}
exports.initTransferMap = initTransferMap;
initTransferMap(document.querySelector('.js-rcg-transfer'));
